import * as HmiFiles from '../../hmilib/hmifiles';

import $ from 'jquery';
import 'jqueryui';
import 'jqueryui/jquery-ui.css';
import { type } from 'os';

let StandartContextMenu = '';

export let NameCommand = '';

let PidaContextMenu = '';

let CurSelectItem = '';

let arrayActionArguments = new Array();

let arrayActionID = new Array();

let arrayCommand = new Array();

let arrayImage = new Array();
export let IndexArrayPage = 0;

export let arrayPage = new Array();

let arrayShortcut = new Array();

let VisibelMenu = false;

export let menuexperionxml = '';

export const OpenMnemo = function (name: string, size?: string, obj?: any) {
    window.OpenMnemoGlobal(name, size, obj);
};

export const OpenWinSpecial = function (name: string, gennum: any, binding: any, curpositionopen: boolean = true) {
    let newid = name + gennum + binding;
    let Specialwinall = document.getElementsByClassName('experionpks_specialwin');
    for (let i = 0; i < Specialwinall.length; i++) {
        Specialwinall[i].classList.remove('experionpks_specialwin_active');
    }

    let clientX = 50;
    let clientY = 50;
    if (window.EventMouseClick) {
        clientX = window.EventMouseClick.clientX + window.LeftMain;
        clientY = window.EventMouseClick.clientY + window.TopMain;
    }

    let specialwinold = document.getElementById(newid);
    if (specialwinold) {
        let Left =
            document.body.offsetWidth - specialwinold.offsetWidth > clientX
                ? clientX
                : document.body.offsetWidth - specialwinold.offsetWidth;
        let Top =
            document.body.offsetHeight - specialwinold.offsetHeight > clientY
                ? clientY
                : document.body.offsetHeight - specialwinold.offsetHeight;
        specialwinold.style.left = Left + 'px';
        specialwinold.style.top = Top - 40 + 'px';
        specialwinold.classList.add('experionpks_specialwin_active');
        return;
    }

    if (Specialwinall.length >= window.MaxSpecialWindow) Specialwinall[0].remove();

    let specialwin = document.createElement('div');

    specialwin.id = name + gennum + binding;
    specialwin.style.zIndex = '10';
    specialwin.style.display = 'block';
    specialwin.style.visibility = 'hidden';
    specialwin.className = 'experionpks_specialwin experionpks_specialwin_active';

    let heatspecial = document.createElement('div');
    heatspecial.className = 'experionpks_specialwin_heatsspecial';
    specialwin.appendChild(heatspecial);

    let heatspecialname = document.createElement('div');
    heatspecialname.className = 'experionpks_specialwin_heatspecialname';
    heatspecialname.style.cursor = 'default';
    heatspecialname.style.userSelect = 'none';
    heatspecial.appendChild(heatspecialname);

    let heatspecialclose = document.createElement('div');
    heatspecialclose.className = 'experionpks_specialwin_heatspecialclose';
    heatspecialclose.innerHTML =
        '<div style="margin-top: 2px;width: 10px;height: 12px;background: #d6d3ce url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAMAAABxsOwqAAAAD1BMVEUAAABCQUKEgoTW087////UP4fJAAAALklEQVR4AWNggQFGBhZmCGACMRmADAYwE0gDIZQJYiFEMdWCATqTCQKATEY4AABFhwEKVtlFMQAAAABJRU5ErkJggg==) left no-repeat;"></div>';
    heatspecial.appendChild(heatspecialclose);

    let heattwo = document.createElement('div');
    heattwo.className = 'experionpks_specialwin_heattwo';
    heattwo.innerHTML =
        '<div style="padding-top: 6px;width: 20px;height: 15px;background: #d6d3ce url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAMAAADTRh9nAAAADFBMVEUAAACEgoTW087/////CW8PAAAAOklEQVR4AZXPUQqAAAzD0MTd/84iFUQpDPP5frZylBYECkbhhZI+aEXFIHcyD5ounMH9UH8J+szfeAIZNAHPzrp1egAAAABJRU5ErkJggg==) left no-repeat;"></div>';
    specialwin.appendChild(heattwo);

    let specialframe = document.createElement('iframe');
    specialframe.className = 'experionpks_specialwin_mnemoframe';
    specialwin.appendChild(specialframe);

    let callbackload = function () {
        let contentWindow = specialframe.contentWindow;

        let svgschem = contentWindow ? contentWindow.document.getElementsByTagName('svg')[0] : null;

        if (svgschem) {
            let heightallborder = 20;
            if (svgschem.viewBox.baseVal.height !== 0)
                specialwin.style.height = svgschem.viewBox.baseVal.height + heightallborder + 'px';
            if (svgschem.viewBox.baseVal.width !== 0) specialwin.style.width = svgschem.viewBox.baseVal.width + 'px';

            if (curpositionopen) {
                let Left =
                    document.body.offsetWidth - specialwin.offsetWidth > clientX
                        ? clientX
                        : document.body.offsetWidth - specialwin.offsetWidth;
                let Top =
                    document.body.offsetHeight - specialwin.offsetHeight > clientY
                        ? clientY
                        : document.body.offsetHeight - specialwin.offsetHeight;
                specialwin.style.left = Left + 'px';
                specialwin.style.top = Top - 40 + 'px';
            } else {
                let cou = document.getElementsByClassName('experionpks_specialwin').length - 1;
                specialwin.style.left = 10 + cou + 'vw';
                specialwin.style.top = 5 + cou + 'vh';
            }

            if (svgschem.hasAttribute('title')) {
                let titl: string = '';
                try {
                    titl = eval(svgschem.getAttribute('title') as string);
                } catch (err) {
                    titl = svgschem.getAttribute('title') as string;
                }

                specialwin.getElementsByClassName('experionpks_specialwin_heatspecialname')[0].innerHTML = titl;

                specialwin
                    .getElementsByClassName('experionpks_specialwin_heatspecialname')[0]
                    .setAttribute('title', titl);
            }

            specialwin.style.visibility = 'visible';

            let autofocus = svgschem.querySelector('input[type="text"]') as any;
            if (autofocus) {
                autofocus.select();
            }
        }
    };

    HmiFiles.OpenMnemo(name, gennum, binding, specialframe, callbackload);

    let mainob = document.getElementById('main');

    if (mainob) {
        mainob.appendChild(specialwin);
    }

    $(specialwin)
        .draggable({
            containment: '#main',
            iframeFix: true,
            handle: '.experionpks_specialwin_heatspecialname',
            scroll: false
        })
        .resizable({
            minHeight: 100,
            minWidth: 100,
            handles: 'all',
            aspectRatio: true,
            containment: '#main',
            start: function (event, ui) {
                $('iframe').css('pointer-events', 'none');
            },
            stop: function (event, ui) {
                $('iframe').css('pointer-events', 'auto');
            }
        });

    heatspecialclose.addEventListener('click', function (elem: any) {
        let windowMnemo = elem.target;
        let maxfor = 20;
        for (let i = 0; i < maxfor; i++) {
            windowMnemo = windowMnemo.parentElement;
            if (windowMnemo.classList.contains('experionpks_specialwin')) break;
        }

        let parentElem = windowMnemo.getElementsByClassName('experionpks_specialwin_mnemoframe')[0];
        HmiFiles.UnSubItem(parentElem.contentDocument || parentElem.contentWindow.document);
        windowMnemo.parentElement.removeChild(windowMnemo);
    });

    specialwin.addEventListener('mousedown', function () {
        let Specialwin = document.getElementsByClassName('experionpks_specialwin_active');
        for (let i = 0; i < Specialwin.length; i++) {
            Specialwin[i].classList.remove('experionpks_specialwin_active');
        }
        this.classList.add('experionpks_specialwin_active');
    });
};

export const ContextMenuDiv = function (ev: any, item: string, typemenu: number, x: number, y: number) {
    let fieldNameElement = document.createElement('div');
    fieldNameElement.id = 'menucontext';
    fieldNameElement.className = 'experionpks_menucontext';
    fieldNameElement.style.position = 'absolute';
    fieldNameElement.style.background = '#fff';
    fieldNameElement.style.width = '150px';
    fieldNameElement.style.zIndex = '9999';
    fieldNameElement.style.top = y.toString() + 'px';
    fieldNameElement.style.left = x.toString() + 'px';

    let IdTrend = '';

    let configarch = window.GetArchiveConfig();
    for (let paramarch in configarch) {
        if (paramarch.indexOf(item) == 0) {
            IdTrend = configarch[paramarch].SettingsGroups[0].Group;
            break;
        }
    }

    let menu =
        '<nav class="context-menu">' +
        '<ul class="context-menu__items">' +
        '<li class="context-menu__item">' +
        '<i class="fa fa-item">' +
        item +
        '</i>' +
        '</li>' +
        '<li class="context-menu__item" onclick="OpenFaceplate(\'' +
        item +
        '\')">' +
        '<i class="fa fa-faceplate">Панель</i>' +
        '</li>' +
        '<li class="context-menu__item" onclick="OpenMnemo(\'Trends?Id=' +
        IdTrend +
        '&SELECT=' +
        item +
        '\')">' +
        '<i class="fa fa-trend">Тренды</i>' +
        '</li>' +
        '</ul>' +
        '</nav>';

    menu = ConvertContext(ev, typemenu, item);

    fieldNameElement.innerHTML = menu;
    //fieldNameElement.innerHTML = menu;

    document.body.appendChild(fieldNameElement);
    return true;
};

export const InitExperionPksSetting = function () {
    //загрузка стандартного меню
    let path = '/ixyber/vision/File/FileDcs?dcs=experion&name=StandartMenu&idpro=' + window.GetIdAndHost().id;
    let xhr = new XMLHttpRequest();
    xhr.open('GET', path, false);
    xhr.overrideMimeType('text/plain');

    xhr.onreadystatechange = function () {
        // Ждём ответа от сервера
        if (xhr.readyState === 4 && xhr.status === 200) {
            StandartContextMenu = xhr.responseText;
        }
    };
    xhr.send();
    //загрузка времменного меню для пробы
    let pathc = '/ixyber/vision/File/FileDcs?dcs=experion&name=sysdtlpida_sm&idpro=' + window.GetIdAndHost().id;
    let xhrc = new XMLHttpRequest();
    xhrc.open('GET', pathc, false);
    xhrc.overrideMimeType('text/plain');
    xhrc.onreadystatechange = function () {
        // Ждём ответа от сервера
        if (xhrc.readyState === 4 && xhrc.status === 200) {
            PidaContextMenu = xhrc.responseText;
        }
    };
    xhrc.send();

    let path2 = '/ixyber/vision/File/FileDcs?dcs=experion&name=menu_experion&idpro=' + window.GetIdAndHost().id;
    let xhr2 = new XMLHttpRequest();
    xhr2.open('GET', path2, false);
    xhr2.overrideMimeType('text/plain');
    xhr2.onreadystatechange = function () {
        if (xhr2.readyState === 4 && xhr2.status === 200) {
            if (xhr2.responseText != '' && xhr2.responseText != null) {
                menuexperionxml = xhr2.responseText;
                ConverterCommand(menuexperionxml);
            }
        }
    };
    xhr2.send();
};

export const SetNameCommand = function (name: string) {
    NameCommand = name;
};

function ConvertContext(ev: any, type: number, item: string) {
    let html = '';
    switch (type) {
        case 1:
            html += ConverterContectMenu(PidaContextMenu, item);
            break;
        case 2:
            html += ConverterContectMenu(StandartContextMenu, '');
            break;
        case 3:
            var div = document.createElement('div');

            var div1 = document.createElement('div');
            var Adiv1 = document.createElement('a');
            Adiv1.setAttribute(
                'style',
                'font-family: sans-serif, arial;text-decoration: none;color: #888888;margin-right: 5px;cursor: default;display: block;width: 140px;font-size: 9pt;'
            );
            Adiv1.innerHTML = '<img src="/ixyber/vision/dcs/experion/images/menu/Toolbar/tb002.bmp">  Acknowldge Alarm';
            div1.appendChild(Adiv1);
            div.appendChild(div1);

            var div5 = document.createElement('div');
            var Adiv5 = document.createElement('a');
            Adiv5.setAttribute(
                'style',
                'font-family: sans-serif, arial;text-decoration: none;color: #888888;margin-right: 5px;cursor: default;display: block;width: 140px;font-size: 9pt;'
            );
            Adiv5.innerHTML = '<img src="/ixyber/vision/dcs/experion/images/menu/Toolbar/tb017.bmp">  Detail Display';
            div5.appendChild(Adiv5);
            div.appendChild(div5);
            var div6 = document.createElement('div');
            var Adiv6 = document.createElement('a');
            Adiv6.setAttribute(
                'style',
                'font-family: sans-serif, arial;text-decoration: none;color: #888888;margin-right: 5px;cursor: default;display: block;width: 140px;font-size: 9pt;'
            );
            Adiv6.innerHTML =
                '<img src="/ixyber/vision/dcs/experion/images/menu/Toolbar/tb003.bmp">  Associated Display';
            div6.appendChild(Adiv6);
            div.appendChild(div6);
            Adiv1.removeAttribute('onclick');
            Adiv5.removeAttribute('onclick');
            Adiv6.removeAttribute('onclick');
            if (ev.target.parentNode.hasAttribute('data-value')) {
                var TempTagName = ev.target.parentNode.getAttribute('data-value');
                var TagNameFull = ev.target.parentNode.getAttribute('alarmname');
                var tagval = window.GetItemList()[TempTagName];
                if (tagval !== undefined) {
                    var mnemoname = tagval.faceplate;
                    mnemoname = mnemoname.split('_')[0];
                    if (mnemoname !== '') {
                        mnemoname = mnemoname + '?TAG=' + TempTagName;
                        Adiv5.setAttribute('onclick', "window.parent.OpenMnemo('" + mnemoname + "')");
                        Adiv5.style.color = 'black';
                        Adiv5.style.cursor = 'pointer';
                    }
                    mnemoname = tagval.associateddisplay;
                    if (mnemoname !== '') {
                        Adiv6.setAttribute('onclick', "window.parent.OpenMnemo('" + mnemoname + "')");
                        Adiv6.style.color = 'black';
                        Adiv6.style.cursor = 'pointer';
                    }
                    Adiv1.setAttribute('onclick', "AlarmsAck('" + TagNameFull + "')");

                    Adiv1.style.color = 'black';
                    Adiv1.style.cursor = 'pointer';
                }
            }

            html += div.innerHTML;
            break;
        default:
            // Nothing
            break;
    }
    return html;
}

function ConverterContectMenu(textmenu: string, item: string) {
    let MainConsMenu, ElementConsMenu, ParametrsConsMenu, Parametr;
    let xmlDoc, parser;
    let html, TempStr;
    let ParamText, ParamIcon, ParamOnClick;
    let NumberElementConsMenu, NumberParametr;
    let ImageIcon = false;

    CurSelectItem = item;

    html = '<div>';

    parser = new DOMParser();
    xmlDoc = parser.parseFromString(textmenu, 'text/xml');
    MainConsMenu = xmlDoc.getElementsByTagName('menu')[0]?.children;
    if (MainConsMenu != null) {
        for (NumberElementConsMenu = 0; NumberElementConsMenu < MainConsMenu.length; NumberElementConsMenu++) {
            ElementConsMenu = MainConsMenu[NumberElementConsMenu];

            if (ElementConsMenu.nodeName == 'menuitem') {
                ParametrsConsMenu = ElementConsMenu.children;
                ImageIcon = false;
                for (NumberParametr = ParametrsConsMenu.length - 1; NumberParametr >= 0; NumberParametr--) {
                    Parametr = ParametrsConsMenu[NumberParametr];

                    if (Parametr != null) {
                        if (Parametr.nodeName == 'text') {
                            if (!ImageIcon)
                                ParamIcon =
                                    '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAPCAYAAAALWoRrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAATSURBVDhPYxgFo2AUjIKRBhgYAAT7AAExr2sKAAAAAElFTkSuQmCC"></img>';
                            ParamText = '  ' + Parametr.textContent + '</a>';
                        } else if (Parametr.nodeName == 'image') {
                            let parchil = Parametr;
                            if (parchil != null) {
                                let arr = parchil.textContent?.split('\\');
                                if (arr != undefined) {
                                    ImageIcon = true;
                                    ParamIcon =
                                        '<img src="/ixyber/vision/dcs/experion/images/menu/' +
                                        arr[1] +
                                        '/' +
                                        arr[2] +
                                        '"></img>';
                                }
                            }
                        } else if (Parametr.nodeName == 'script') {
                            if (Parametr.getAttribute('type') == 'onclick') {
                                let parchil = Parametr;
                                if (parchil != null) {
                                    let arr1 = parchil.textContent?.split("'");
                                    if (arr1 != undefined) {
                                        ParamOnClick = FindCommand(arr1[1], true);
                                    }
                                }
                            }
                        }
                    }
                }
                html = html + '<div>' + ParamOnClick + ParamIcon + ParamText + '</div>';
            }
            if (ElementConsMenu.nodeName == 'separator') {
                html = html + '<hr>';
            }
        }
    }
    html += '</div>';
    return html;
}

//Поиск комманд
export const FindCommand = function (StringName: string, TrueMenu: boolean) {
    var html = '';
    var indexArray = -1;

    indexArray = arrayCommand.indexOf(StringName);

    if (indexArray != -1) {
        html = ViewCommand(indexArray, TrueMenu);
    } else html = '<a>';
    return html;
};

export const ViewCommand = function (indexArray: number, TrueMenu: boolean) {
    var html = '';
    switch (arrayActionID[indexArray]) {
        case 'Callup Page':
            if (TrueMenu) html = '<a onclick="OpenMnemo' + "('" + arrayActionArguments[indexArray] + "')" + '">';
            else html = '<a onclick="OpenMnemo' + "('" + arrayActionArguments[indexArray] + "')" + '">';
            break;
        case '[Navigation] Back':
            if (TrueMenu) html = '<a onclick="onClickNavigation(' + "'Back'" + ')">';
            else html = '<ul class="experion_MenuNav"><li><a class="main"> ';
            break;
        case '[Navigation] Forward':
            if (TrueMenu) html = '<a onclick="onClickNavigation(' + "'Forward'" + ')">';
            else html = '<ul class="experion_MenuNav"><li><a class="main"> ';
            break;
        case '[Navigation] Refresh':
            html = '<a onclick="onClickNavigation(' + "'Refresh'" + ')">';
            break;
        case 'Request Trend':
            if (TrueMenu) html = '<a onclick="OpenMnemo(' + "'Trends?TAG=" + CurSelectItem + "'" + ')">';
            else html = '<a onclick="OpenMnemo(' + "'Trends?TAG=" + CurSelectItem + "'" + ')">';
            break;
        case 'Request Point Detail':
            if (CurSelectItem != null) {
                var tag = CurSelectItem.toUpperCase();
                var tagval = window.GetItemList()[tag];
                if (tagval !== undefined) {
                    var mnemoname = tagval.faceplate;
                    mnemoname = mnemoname.split('_')[0];
                    if (mnemoname !== '') {
                        mnemoname = mnemoname + '?TAG=' + tag;
                    }
                    html = '<a onclick="OpenMnemo(' + "'" + mnemoname + "'" + ')">';
                } else html = '<a onclick="OpenDetalil()">';
            } else html = '<a onclick="OpenDetalil()">';
            break;
        case 'Associated Display':
            if (CurSelectItem != null) {
                var tag = CurSelectItem.toUpperCase();
                var tagval = window.GetItemList()[tag];
                if (tagval !== undefined) {
                    var mnemoname = tagval.associateddisplay;
                    if (mnemoname !== '') {
                        html = '<a onclick="OpenMnemo(' + "'" + mnemoname + "'" + ')">';
                    } else {
                        html = '<a onclick="OpenDetalil()">';
                    }
                } else html = '<a onclick="OpenDetalil()">';
            } else html = '<a onclick="OpenDetalil()">';
            break;
        case 'Request Group':
            if (TrueMenu && CurSelectItem != null) {
                var tag = CurSelectItem.toUpperCase();
                html = '<a onclick="ExperionScript.OpenPage(\'GroupTags?TAG=' + tag + '\')">';
            } else html = '<a onclick="ExperionScript.OpenPage(\'GroupTags?TAG=null\')">';
            break;
        //case ("Acknowledge Alarm"):
        //    html = '<a href="' + location.href + '" onclick="WebDA.SetParam(' + "'" + CurSelectItem+"$ACK'"+', 1)">';
        //    break;
        default:
            html = '<a>';
            break;
    }
    return html;
};

export const ConverterCommand = function (TextConverter: string) {
    var MainCommand, ElementCommand;
    var xmlDoc, parser;
    var TempStr;

    parser = new DOMParser();
    xmlDoc = parser.parseFromString(TextConverter, 'text/xml');
    MainCommand = xmlDoc.getElementsByTagName('Commands')[0]?.children;

    if (MainCommand != null) {
        let arrayCommandTemp = new Array();
        let arrayImageTemp = new Array();
        let arrayActionIDTemp = new Array();
        let arrayShortcutTemp = new Array();
        for (let NumberElementCommand = 0; NumberElementCommand < MainCommand.length; NumberElementCommand++) {
            ElementCommand = MainCommand[NumberElementCommand];

            if (ElementCommand.nodeName == 'Command') {
                arrayCommandTemp[NumberElementCommand] = ElementCommand.getAttribute('CommandID');
                arrayImageTemp[NumberElementCommand] = ElementCommand.getAttribute('Image');
                arrayActionIDTemp[NumberElementCommand] = ElementCommand.getAttribute('ActionID');
                switch (ElementCommand.getAttribute('CommandID')) {
                    case 'Alarms':
                        arrayActionArguments[NumberElementCommand] = 'Alarms';
                        break;
                    case 'Trend Summary':
                        arrayActionArguments[NumberElementCommand] = 'Trends';
                        break;
                    default:
                        var TempSTR = ElementCommand.getAttribute('ActionArguments');
                        if (TempSTR != null) {
                            if (TempSTR.indexOf('.') > 0)
                                arrayActionArguments[NumberElementCommand] = TempSTR.substring(0, TempSTR.indexOf('.'));
                            else arrayActionArguments[NumberElementCommand] = TempSTR;
                        }
                        break;
                }
                let commnew = ElementCommand.getAttribute('Shortcut');
                if (commnew != null) {
                    arrayShortcut[NumberElementCommand] = commnew;
                } else {
                    arrayShortcut[NumberElementCommand] = '';
                }
            }
        }

        arrayCommand = arrayCommandTemp;
        arrayImage = arrayImageTemp;
        arrayActionID = arrayActionIDTemp;
        arrayShortcut = arrayShortcutTemp;
    }
};

export const FindImage = function (StringName: string, menu: boolean) {
    var html = '';
    var indexArray = -1;
    var TempStr = '';
    var TempName = '';

    indexArray = arrayCommand.indexOf(StringName); //ищим индык с такой командой

    if (indexArray != -1) {
        TempStr = arrayImage[indexArray];
        if (TempStr != '') {
            if (menu)
                TempName = 'Menu ' + StringName; //если для меню
            else TempName = 'Image ' + StringName; //если другое

            if (TempName == 'Image [Navigation] Forward') {
                //для картинок навигации Forward
                html =
                    '<img src="/ixyber/vision/dcs/experion/images/menu/' +
                    TempStr +
                    '" id="' +
                    TempName +
                    '" title="' +
                    NameCommand +
                    '"onclick="onClickNavigation(' +
                    "'Forward'" +
                    ')"></img>';
                window.ConverImageBase64('/ixyber/vision/dcs/experion/images/menu/' + TempStr, TempName);
                html = html + '<img src="/ixyber/vision/dcs/experion/images/menu/arrow2.gif" id="Forward"></img>';
                html = html + '</a><ul id="ulforward"></ul></li></ul>';
            } else if (TempName == 'Image [Navigation] Back') {
                //для картинок навигации Back
                html =
                    '<img src="/ixyber/vision/dcs/experion/images/menu/' +
                    TempStr +
                    '" id="' +
                    TempName +
                    '" title="' +
                    NameCommand +
                    '"onclick="onClickNavigation(' +
                    "'Back'" +
                    ')"></img>';
                window.ConverImageBase64('/ixyber/vision/dcs/experion/images/menu/' + TempStr, TempName);
                html =
                    html +
                    '<img src="/ixyber/vision/dcs/experion/images/menu/arrow2.gif" id="Back" onclick="onclickMenuBack()"></img>';
                html = html + '</a><ul id="ulback"></ul></li></ul>';
            } else {
                html =
                    '<img src="/ixyber/vision/dcs/experion/images/menu/' +
                    TempStr +
                    '" id="' +
                    TempName +
                    '" title="' +
                    NameCommand +
                    '"></img>';
                window.ConverImageBase64('/ixyber/vision/dcs/experion/images/menu/' + TempStr, TempName);
            }
        } else if (menu)
            html =
                '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZSURBVEhL7cExAQAAAMKg9U9tCU8gAICDGghWAAHPSM1fAAAAAElFTkSuQmCC" alt="' +
                StringName +
                '" align="left" height=18px></img>';
        else if (StringName == 'Zoom')
            html =
                '<select size="1"><option>Zoom To Fit</option><option>200%</option><option>150%</option><option>125%</option><option>100%</option><option>80%</option><option>60%</option><option>50%</option><option>30%</option></select>';
        else if (StringName == 'None') html = '<a><b>' + NameCommand + '</b></a>';
        else if (StringName == 'Command Zone')
            html = '<input type="Command" id="Command" size="40" onkeypress="return ExperionCommand(event)">';
        else if (arrayActionID[indexArray] == 'Callup Page') html = '<b>' + NameCommand + '</b>';
        else html = '<a><b>' + StringName + '</b></a>';
    } else
        html =
            '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZSURBVEhL7cExAQAAAMKg9U9tCU8gAICDGghWAAHPSM1fAAAAAElFTkSuQmCC" alt="' +
            StringName +
            '" align="left" height=18px></img>';

    return html;
};

window.ExperionCommand = function (e: any) {
    if (e.keyCode == 13) {
        OpenMnemo(e.target?.value);
        return false;
    }
};

let ChangeCommand = function (event: any) {};

let ConverChilds = function (childs: any): string {
    let Txt, ElementChilds, Element;
    let TempStr;
    let One = true;

    let NumberElementMenu = 0;

    let MaxLength = 1;
    Txt = '<ul>';

    for (
        NumberElementMenu = 0;
        NumberElementMenu < childs.length;
        NumberElementMenu++ //В цикле перебираем все дочернии элементы
    ) {
        Element = childs[NumberElementMenu];
        if (Element.nodeName === 'Item') {
            //Если это элемент
            TempStr = Element.getAttribute('CommandID');
            Txt = Txt + '<li>' + FindCommand(TempStr, false);

            Txt = Txt + FindImage(TempStr, true);
            Txt = Txt + Element.getAttribute('Caption');
            Txt = Txt + '</a></li>';
        }
        if (Element.nodeName === 'Separator') {
            //Если это разделитель
            // One = true;
            Txt = Txt + '<li><hr></li>';
        }
        if (Element.nodeName === 'Menu') {
            //Если это меню
            Txt = Txt + '<li class="fly">';

            Txt = Txt + '<a>';
            Txt = Txt + FindImage(TempStr, true); //картинка
            Txt = Txt + Element.getAttribute('Caption'); //название

            Txt = Txt + '</a>';

            ElementChilds = Element.childNodes;
            Txt = Txt + ConverChilds(ElementChilds);

            Txt = Txt + '</li>';
        }
    }
    Txt = Txt + '</ul>';
    return Txt;
};
